/* eslint-disable max-len */
/*
 *  PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2026 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/*
 * A React component for FeedbackInfoIcon
 *
 * @author Satyaki Bose
 */

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const FeedbackInfoIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 18 18" fontSize="inherit">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0ZM9.00001 1.75C4.99595 1.75 1.75001 4.99593 1.75001 9C1.75001 13.0041 4.99595 16.25 9.00001 16.25C13.0041 16.25 16.25 13.0041 16.25 9C16.25 4.99593 13.0041 1.75 9.00001 1.75ZM9.50003 7C9.77617 7 10 7.22386 10 7.5V13.5C10 13.7761 9.77617 14 9.50003 14H8.50003C8.22388 14 8.00003 13.7761 8.00003 13.5V7.5C8.00003 7.22386 8.22388 7 8.50003 7H9.50003ZM9.50003 4C9.77617 4 10 4.22386 10 4.5V5.5C10 5.77614 9.77617 6 9.50003 6H8.50003C8.22388 6 8.00003 5.77614 8.00003 5.5V4.5C8.00003 4.22386 8.22388 4 8.50003 4H9.50003Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default FeedbackInfoIcon;
